import * as React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import Card from "@material-ui/core/Card";
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";

const styles = (theme) => ({
  card: {
    backgroundColor: theme.palette.grey[50],
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    marginBottom: "3%",
  },
  title: {
    color: theme.palette.primary.main,
    fontWeight: 500,
  },
  row: {
    marginBottom: "2%",
  },
  data: {
    fontSize: "13px",
    [theme.breakpoints.down("md")]: {
      display: "inline-block",
    },
  },
  label: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    width: "100%",
    fontSize: "12px",
  },
  wrapper: {
    padding: "20px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    [theme.breakpoints.down("lg")]: {
      width: "94%",
    },
  },
  tag: {
    width: "100%",
    textAlign: "center",
    backgroundColor: theme.palette.grey[300],
    padding: "6px",
    fontSize: "14.7px",
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
});

const DataBox = ({ fields, title, actions = [], classes, className = "" }) => (
  <Card className={`${classes.card} ${className}`}>
    <Grid container>
      {title && (
        <Grid item className={classes.tag}>
          {title}
        </Grid>
      )}
      <Grid item className={classes.wrapper}>
        {fields
          .filter(([label, value]) => value) // value must be non-empty string
          .map(([label, value], i) => (
            <div className={classes.row} key={i}>
              <div className={`${classes.data} ${classes.label}`}>{label}</div>
              <div className={classes.data}>{value}</div>
            </div>
          ))}
        {actions.length > 0 &&
          actions.map((btn, i) => (
            <React.Fragment key={i}>{btn}</React.Fragment>
          ))}
      </Grid>
    </Grid>
  </Card>
);

DataBox.propTypes = {
  fields: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
  title: PropTypes.string,
  actions: PropTypes.array,
};

export default withStyles(styles)(DataBox);



// WEBPACK FOOTER //
// ./src/components/UI/DataBox.jsx